<template>
  <v-row>
    <v-col>
      <p>{{ text }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    text: { type: String },
  },
};
</script>
